import { NgModule } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { ChannelContentLibraryModule } from '@tokeet-frontend/channel-content'
import { PhotoCardComponent } from './photo-card.component'

@NgModule({
  imports: [SharedModule, ChannelContentLibraryModule],
  declarations: [PhotoCardComponent],
  exports: [PhotoCardComponent],
})
export class PhotoCardModule {}
